
import { defineComponent } from "vue";

export default defineComponent({
  name: "MainButton",
  props: ["type", "label", "color", "isDisabled", "bordered", "customClass"],
  emits: ["clicked"],
});
